module.exports = __webpack_public_path__ + "img/back.180ff50e.svg";